import {get, put, post, del, default as com} from '@/common/api'

const api = {
  // 号别
  saveRegType:(para)=>{
    if (para.id) {
      return put(`/api/op/regType/${para.id}`, para)
    } else {
      return post('/api/op/regType', para)
    }
  },
  delRegType(id) {
    return del(`/api/op/regType/${id}`)
  },
  queryRegTypes : com.queryRegType
  ,
  getRegType(id) {
    return get(`/api/op/regType/${id}`)
  },
  // 费用标准
  saveFeeStandard: para => para.id ? put(`/api/op/feeStandard/${para.id}`, para) : post(`/api/op/feeStandard`, para),
  delFeeStandard: id => del(`/api/op/feeStandard/${id}`),
  getFeeStandard: id => get(`/api/op/feeStandard/${id}`),
  queryFeeStandard: para => get(`/api/op/feeStandard`, para)
}

export default api
